import { FILTER_TAB_ENUM } from './../enum/marketing-builder';
import { CampaignBlockDTO } from '@soctrip/angular-marketing-hub-service';
import { BLOCK_TYPE, TAB_EFFECT_IMAGE } from '../enum/marketing-builder';
import { SoctripIcons } from './soctrip-icon.enum';

export const BLOCKS_BUILDER = [
  {
    name: 'Text',
    value: BLOCK_TYPE.TEXT,
    icon: SoctripIcons.TYPE_01,
  },
  {
    name: 'Image',
    value: BLOCK_TYPE.IMAGE,
    icon: SoctripIcons.IMAGE_03,
  },
  {
    name: 'Slide',
    value: 'SLIDE',
    icon: SoctripIcons.COLUMNS_02,
  },
  {
    name: 'Video',
    value: 'VIDEO',
    icon: SoctripIcons.VIDEO_RECORDER,
  },
  {
    name: 'Tab',
    value: 'TAB',
    icon: SoctripIcons.PASSCODE,
  },
  {
    name: 'Product list',
    value: 'PRODUCT_LIST',
    icon: SoctripIcons.PACKAGE,
  },
  {
    name: 'Voucher',
    value: 'VOUCHER',
    icon: SoctripIcons.TICKET_01,
  },
];

export const LAYOUTS_BUILDER = [
  {
    code: 'ONE_ONE',
    value: [1],
  },
  {
    code: 'TWO_TWO',
    value: [1, 1],
  },
  {
    code: 'THREE_ONE',
    value: [1, 1, 1],
  },
  {
    code: 'FOUR_ONE',
    value: [1, 1, 1, 1],
  },
  {
    code: 'FIVE_ONE',
    value: [1, 1, 1, 1, 1],
  },
  {
    code: 'TWO_TWO_THREE',
    value: [1, 2],
  },
  {
    code: 'TWO_THREE_TWO',
    value: [2, 1],
  },
];

export const IMAGE_ALIGNS = [
  {
    value: CampaignBlockDTO.AlignmentEnum.LEFT,
    icon: SoctripIcons.ALIGN_LEFT,
  },
  {
    value: CampaignBlockDTO.AlignmentEnum.CENTER,
    icon: SoctripIcons.ALIGN_CENTER,
  },
  {
    value: CampaignBlockDTO.AlignmentEnum.RIGHT,
    icon: SoctripIcons.ALIGN_RIGHT,
  },
];

export const FILTERS_PRODUCT_BY = [
  {
    name: 'Promotion programs',
    value: 'PROMOTION',
  },
  {
    name: 'Keywords',
    value: 'KEYWORD',
  },
];

export const SORT_ITEMS = [
  {
    scope: 'string',
    name: 'A to Z',
    value: 1,
  },
  {
    scope: 'string',
    name: 'Z to A',
    value: -1,
  },
  {
    scope: 'number',
    name: 'High to low',
    value: -1,
  },
  {
    scope: 'number',
    name: 'Low to high',
    value: 1,
  },
];

export const STARS = [1, 2, 3, 4, 5];

export const IMAGE_EFFECTS = [
  {
    value: TAB_EFFECT_IMAGE.ANIMATE,
    title: 'Animate',
  },
  {
    value: TAB_EFFECT_IMAGE.CUSTOM,
    title: 'Custom',
  },
];

export const CURVE_OPTIONS = [
  {
    name: 'None',
    value: CampaignBlockDTO.CurveEnum.NONE,
  },
  {
    name: 'Ease in',
    value: CampaignBlockDTO.CurveEnum.EASEIN,
  },
  {
    name: 'Ease out',
    value: CampaignBlockDTO.CurveEnum.EASEOUT,
  },
  {
    name: 'Ease in out',
    value: CampaignBlockDTO.CurveEnum.EASEINOUT,
  },
  {
    name: 'Fade in',
    value: CampaignBlockDTO.CurveEnum.FADEIN,
  },
  {
    name: 'Linear',
    value: CampaignBlockDTO.CurveEnum.LINEAR,
  },
];

export const FILTER_TAB = [
  { name: 'filters', value: FILTER_TAB_ENUM.FILTERS },
  { name: 'specific-products', value: FILTER_TAB_ENUM.SPECIFIC_PRODUCTS },
];
